import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {ClassifiedsService} from "../../../services/classifieds.service";

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'classifieds-list',
    templateUrl: './classifieds-list.component.html',
    styleUrls: ['./classifieds-list.component.scss']
})
export class ClassifiedsListComponent {

    constructor(
        public urlService: UrlService,
        public classifiedsService: ClassifiedsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.classifiedsService.data.allClassifieds.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    signOutKey(keyLog) {
        this.classifiedsService.signOutKey(keyLog);
    }

    returnKey(keyLog) {
        this.classifiedsService.returnKey(keyLog);
        keyLog.showDropdown = false;
    }

    getHistory(keyLog) {
        this.classifiedsService.getHistory(keyLog);
        keyLog.showDropdown = false;
    }

    deleteKeyLog(keyLog) {
        this.classifiedsService.deleteKeyLog(keyLog);
        keyLog.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds-list/classifieds-list.component.ts